import { gameState } from '../state/gameState.js';
import { GAME_WIDTH } from '../config.js';
import { iconText } from './iconText.js';
import { PALETTE } from './gameUiStyle.mjs';

// The coin counter, top-right: a wooden pill (the gameUi look) with the coin icon.
export class MoneyBar {
  constructor(scene) {
    this.scene = scene;
    const W = PALETTE.wood;
    this.w = 220; this.h = 50;
    // Fixed HUD: pinned to the camera (scroll factor 0) so it stays top-right even in
    // scrolling scenes like the street, and above world sprites.
    this.bg = scene.add.graphics().setScrollFactor(0).setDepth(50);
    this.bg.setPosition(GAME_WIDTH - 140, 30);
    this.bg.fillStyle(W.dark, 1); this.bg.fillRoundedRect(0, -this.h / 2 + 4, this.w, this.h, this.h / 2);
    this.bg.fillStyle(W.fill, 1); this.bg.fillRoundedRect(0, -this.h / 2, this.w, this.h, this.h / 2);
    // (no light stripe along the top: owner 2026-09-30, like the buttons)
    this.text = iconText(scene, GAME_WIDTH - 124, 30, '', {
      fontFamily: 'system-ui', fontSize: '24px', color: W.text, fontStyle: 'bold', stroke: W.stroke, strokeThickness: 4,
    }).setOrigin(0, 0.5).setScrollFactor(0).setDepth(50);
    this._unsub = gameState.on(() => this.refresh());
    scene.events.on('shutdown', () => this._unsub());
    scene.events.on('destroy', () => this._unsub());
    this.refresh();
  }

  refresh() {
    const money = gameState.raw?.money ?? 0;
    const s = `{coin} ${money}`;
    if (this.text.text !== s) this.text.setText(s);
  }
}
